import axios from "axios";

import { apiBaseUrl } from "./native";

// In a packaged app the page is served by the WebView from https://localhost,
// so a relative "/api/v1" would never reach the server - apiBaseUrl() returns
// an absolute URL there and the relative one on the web.
const API = axios.create({
  baseURL: apiBaseUrl(),
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('dav_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A rejected token must not leave the operator staring at empty panels:
// broadcast it so App.js can clear the session and show the login screen.
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("dav_token");
      window.dispatchEvent(new Event("dav:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export default API;
